import * as containers from './containers'
import * as components from './components'
import * as links from './links'

const routes = [
  {
    path: links.ORDER_DETAILS.URL,
    component: components.Layout,
    routes: [
      {
        path: links.ORDER_DETAILS.URL,
        exact: true,
        component: containers.OrderDetails
      },
      {
        path: links.PAYMENT.URL,
        exact: true,
        component: containers.Payment
      },
      {
        path: links.ACCEPTED,
        component: components.Accepted
      }
    ]
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/features/OrderDetails/routes.js